<template>
  <div class="not-found flex items-center justify-center">
    
    <Link class="padding-10 color-eerie-black" to="/" border="1px dashed #1c1c1c">
      <Icon name="arrow-left-circle-fill" />
      <Text text="Sayfa bulunamadı, anasayfaya dön" />
    </Link>
    
  </div>
</template>
